import React from "react";
import { alpha, Card, CardProps } from "@mui/material";

export const hoverCardSx = {
  borderRadius: 3,
  border: "1px solid",
  borderColor: "divider",
  transition: "box-shadow .2s ease, border-color .2s ease, transform .2s ease",
  "&:hover": {
    transform: "translateY(-2px)",
    borderColor: "primary.main",
    boxShadow: (t: any) => `0 8px 24px ${alpha(t.palette.primary.main, 0.18)}`
  }
} as const;

const HoverCard: React.FC<CardProps> = ({ sx, children, ...rest }) => (
  <Card elevation={0} sx={{ ...hoverCardSx, ...sx }} {...rest}>
    {children}
  </Card>
);

export default HoverCard;
